import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeControlService } from 'pr1-ui-components';

@Component({
  selector: 'app-coupon-assets',
  templateUrl: './coupon-assets.component.html',
  styleUrls: ['./coupon-assets.component.scss'],
})

export class CouponAssetsComponent implements OnInit {
  couponId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authorizationService: AuthorizeControlService
  ) { }

  ngOnInit(): void {
    this.couponId = this.route.snapshot.params['couponId'];
  }

  cancel(): void {
    this.router.navigate([`../../`], { relativeTo: this.route, queryParamsHandling: 'preserve' });
  }

  canEdit(): boolean {
    return this.authorizationService.checkAccess('edit||offermang');
  }

}
